import { render, staticRenderFns } from "./Leaderboards.vue?vue&type=template&id=6ecca942&scoped=true"
import script from "./Leaderboards.vue?vue&type=script&lang=js"
export * from "./Leaderboards.vue?vue&type=script&lang=js"
import style0 from "./Leaderboards.vue?vue&type=style&index=0&id=6ecca942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecca942",
  null
  
)

export default component.exports